var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginProfileV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 43,
    viewBox: "0 0 57 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2703_5354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42545 8.26599V19.718L44.3942 19.718V8.26599L8.42545 8.26599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1407 19.704H44.3943V8.26318L33.5863 8.27998C31.4275 12.088 29.2463 15.9072 27.1407 19.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5275 23.498H9.74986C9.42975 23.498 9.17026 23.7575 9.17026 24.0776V24.2316C9.17026 24.5517 9.42975 24.8112 9.74986 24.8112H26.5275C26.8476 24.8112 27.1071 24.5517 27.1071 24.2316V24.0776C27.1071 23.7575 26.8476 23.498 26.5275 23.498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5275 27.3816H9.74986C9.42975 27.3816 9.17026 27.6411 9.17026 27.9612V28.1152C9.17026 28.4353 9.42975 28.6948 9.74986 28.6948H26.5275C26.8476 28.6948 27.1071 28.4353 27.1071 28.1152V27.9612C27.1071 27.6411 26.8476 27.3816 26.5275 27.3816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4775 17.1532H52.1447V1.19318H1.11185V35.4092H18.5866V40.0012H16.2178V41.4796H37.0387V40.0012H34.5466V35.4092H42.4118V38.5928C42.4126 39.3582 42.717 40.092 43.2582 40.6332C43.7994 41.1744 44.5333 41.4788 45.2987 41.4796H53.4803C54.2452 41.4781 54.9783 41.1734 55.5189 40.6322C56.0595 40.0911 56.3635 39.3577 56.3643 38.5928V20.0372C56.3635 19.272 56.059 18.5385 55.5177 17.9977C54.9764 17.4569 54.2426 17.1532 53.4775 17.1532ZM42.4091 20.0372V34.0708H2.45025V2.53998H50.8063V17.1532H45.2959C44.5307 17.1532 43.7969 17.4569 43.2556 17.9977C42.7143 18.5385 42.4098 19.272 42.4091 20.0372ZM51.3943 18.6568V18.8892H47.3511V18.6596L51.3943 18.6568ZM49.3867 40.4968C49.2088 40.4973 49.0347 40.4451 48.8865 40.3467C48.7384 40.2482 48.6227 40.1081 48.5543 39.9439C48.4858 39.7797 48.4676 39.5989 48.502 39.4244C48.5363 39.2498 48.6217 39.0894 48.7473 38.9634C48.8729 38.8374 49.0331 38.7516 49.2075 38.7167C49.3819 38.6817 49.5628 38.6994 49.7272 38.7673C49.8916 38.8353 50.0321 38.9505 50.131 39.0983C50.2299 39.2462 50.2826 39.4201 50.2827 39.598C50.279 39.8334 50.1831 40.058 50.0155 40.2235C49.8479 40.389 49.6221 40.4821 49.3867 40.4828V40.4968ZM55.1967 37.7836H43.5739V20.0372C43.5767 19.9527 43.5851 19.8685 43.5991 19.7852H55.1715C55.1868 19.8683 55.1952 19.9526 55.1967 20.0372V37.7836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2703_5354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 42,
    fill: "white",
    transform: "translate(0.666656 0.40918)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginProfileV2);
export default __webpack_public_path__ + "static/media/login_profile_v2.65b110d142f88dcb04eb8b3e4504e34f.svg";
export { ForwardRef as ReactComponent };